/* globals getApp  getCurrentPages swan */
import { reqPathTo } from './env';
import { act } from './navigate.js';
import { request } from './request.js';

/**
 * 获取咨询相关信息
 * @param {String} qcNo 律师的qcNo
 */

export function getConsultInfo(qcNo) {
  let qcCoreNum = qcNo && qcNo.slice(-6) || '';
  const url = reqPathTo('consultinfov2', {
    qc_core_num: qcCoreNum,
    vn: 'law'
  }, '', 'falv/lawyer');
  return new Promise(resolve => {
    request({
      url
    }).then(res => {
      let data = res && res.data && res.data.data || {};
      if (!data) {
        resolve({});
        return;
      }
      let {
        target
      } = data || {};
      // 替换成新的支付页面链接
      if (target) {
        data.target = target.replace('/pages/phonechange/index', '/pages/directionalConsult/call');
      }
      resolve({
        consult_service: data
      });
    }).catch(() => {
      resolve({});
    });
  });
}
/**
 *  点击咨询时跳转页面
 * @param {String} qcNo 律师的qcNo
 * @param {Object} urlParams url附加参数
 * @param {Boolean} isClickBtn 是否点击咨询按钮，有智能体跳转智能体，没有智能体跳转律师主页，并弹窗
 */

export const consultPageChange = (qcNo, urlParams = {}, isClickBtn = true) => {
  getConsultInfo(qcNo).then(res => {
    let {
      target_url: target,
      can_agent_consult,
      agent_id,
      wenxin_agent_url
    } = res.consult_service || {};
    // 有智能体

    if (target) {
      for (let key in urlParams) {
        if (target.indexOf('?') === -1) {
          target += '?';
        }
        if (urlParams[key]) {
          target += `&${key}=${urlParams[key]}`;
        }
      }
      if (!isClickBtn) {
        target = target.replace(/action=consult/, '');
      }
      act({
        target,
        type: 'url'
      });
    }
  }).catch(() => {});
};

/**
 *  提交咨询请求
 * @param {Object} data
 * @param {String} data.phone 律师电话
 * @param {String} data.uk 律师 uk
 * @param {String} data.title 咨询问题
 * @param {Number} data.type 咨询类型,免费预约咨询是1，免费电话咨询是2
 * @param {String} data.code 验证码
 * @param {String} data.code_type 对应 /falv/common/sendcode的type
 */

export const submitConsult = data => {
  const {
    phone = '',
    uk = '',
    title = '',
    type,
    lawyer_phone = '',
    fr = '',
    code = '',
    code_type = ''
  } = data || {};
  return new Promise((resolve, reject) => {
    request({
      url: reqPathTo('add_consult', {}, '', 'falv/consult1v1'),
      method: 'post',
      data: {
        ...data,
        phone,
        uk,
        title,
        fr,
        lawyer_phone,
        consult_type: type || 1,
        // 免费预约咨询是1，免费电话咨询是2
        code,
        code_type
      },
      header: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      const data = res && res.data || {};
      if (+data.status !== 0) {
        reject(data);
        return;
      }
      resolve(data);
    }).catch(() => {
      reject();
    });
  });
};